/**
 * The enumeration defines possible actors for FIM data access activities.
 *
 * @see: https://github.com/Microsoft/MIMWAL/blob/master/src/WorkflowActivityLibrary/Enumerations/ActorType.cs
 */
export enum ActorType {
  /**
   * Use FIM Service as the actor for FIM data access.
   */
  Service,

  /**
   * Use Requestor as the actor for FIM data access.
   */
  Requestor,

  /**
   * Resolve the reference as the actor for FIM data access.
   */
  Resolve,

  /**
   * Use the specified account as the actor for FIM data access.
   */
  Account,
}
